// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DD2_","question":"styles_question__1DW1R","description":"styles_description__3P7Dt"};